import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { GestaoEnvioContext } from 'app/main/gestaoenvio/GestaoEnvioContext';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext } from 'react';
import { GestaoEnvioModais } from '../GestaoEnvioModais';
import GestaoEnvioBuscaAvancadaForm from './GestaoEnvioBuscaAvancadaForm';

const GestaoEnvioBuscaAvancadaModal = ({ fetchGestoesEnvio }) => {
  const [modal, setModal] = useContext(GestaoEnvioContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(GestaoEnvioContext).filtroAvancado;
  const [search] = useContext(GestaoEnvioContext).search;
  const [size] = useContext(GestaoEnvioContext).size;
  const [sort] = useContext(GestaoEnvioContext).sort;

  const handleSubmit = (values) => {
    const filtroAvancado = {
      ...values,
      clienteId: values.cliente?.id,
      periodoEnvioInicio: values.periodoEnvioInicio?.format('YYYY-MM-DD'),
      periodoEnvioFim: values.periodoEnvioFim?.format('YYYY-MM-DD'),
    };

    setFiltroAvancado(filtroAvancado);
    fetchGestoesEnvio({ q: search, filtroAvancado, size, sort });
    setModal('');
  };

  const formik = useFormik({
    initialValues: {
      periodoEnvioInicio: filtroAvancado?.periodoEnvioInicio ? moment(filtroAvancado.periodoEnvioInicio) : undefined,
      periodoEnvioFim: filtroAvancado?.periodoEnvioFim ? moment(filtroAvancado.periodoEnvioFim) : undefined,
      cliente: filtroAvancado?.cliente,
      email: filtroAvancado?.email,
      situacaoEnvio: filtroAvancado?.situacaoEnvio,
      tipoEnvio: filtroAvancado?.tipoEnvio,
    },
    onSubmit: handleSubmit,
  });

  const handleCancelar = () => {
    const close = () => {
      formik.resetForm(formik.initialValues);
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  return (
    <SimpleDialog open={modal === GestaoEnvioModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<GestaoEnvioBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default GestaoEnvioBuscaAvancadaModal;
